<template>
  <!--
    作者：rj.wu
    时间：2021-06-28
    描述：插件中心-三人拼团-基础设置
  -->
  <div>
    <el-form size="small" ref="form" :model="form" label-width="100px" v-if="form">
      <!-- <el-form-item label="是否开启功能" prop="is_open">
        <el-switch v-model="form.is_open"></el-switch>
      </el-form-item> -->

      <el-form-item label="是否填写表单" prop="is_form">
        <el-radio-group v-model="form.is_form">
          <el-radio :label="1">需要填写</el-radio>
          <el-radio :label="0">不需要</el-radio>
        </el-radio-group>
      </el-form-item>

      <el-form-item label="考试名称">
        <el-input v-model="form.graduate_student_name" class="max-w460"></el-input>
      </el-form-item>
      
      <el-form-item label="考试时间">
        <el-date-picker v-model="form.graduate_student_date" type="date" value-format="yyyy-MM-dd" placeholder="选择日期"></el-date-picker>
      </el-form-item>

      <el-form-item label="排名更新时间">
        <el-input v-model="form.update_pm_time" class="max-w460" style="width:200px">
          <template slot="append">秒</template>
        </el-input>
      </el-form-item>

      <el-form-item label="会员等级有效时间">
        <el-input v-model="form.user_grade_valid_day" class="max-w460" style="width:200px">
          <template slot="append">天</template>
        </el-input>
      </el-form-item>

      <el-form-item label="激活码有效时间">
        <el-input v-model="form.code_valid_day" class="max-w460" style="width:200px">
          <template slot="append">天</template>
        </el-input>
      </el-form-item>

      <el-form-item label="是否打开纠错及首页打卡">
        <el-radio-group v-model="form.open_correction">
          <el-radio :label="1">打开</el-radio>
          <el-radio :label="0">关闭</el-radio>
        </el-radio-group>
      </el-form-item>

      <el-form-item label="是否打开反馈">
        <el-radio-group v-model="form.open_feedback">
          <el-radio :label="1">打开</el-radio>
          <el-radio :label="0">关闭</el-radio>
        </el-radio-group>
      </el-form-item>

      <!-- <el-form-item label="标签">
        <el-tag :key="tag" v-for="tag in form.tags" closable :disable-transitions="false" @close="tagClose(tag)">
          {{tag}}
        </el-tag>
        <el-input class="input-new-tag" v-if="tagVisible" v-model="tagValue" ref="tagInput" size="small"
          @keyup.enter.native="tagInputConfirm"
          @blur="tagInputConfirm"
        >
        </el-input>
        <el-button v-else class="button-new-tag" size="small" @click="tagInput">+ 标签</el-button>
      </el-form-item> -->

      <div class="common-form">打卡设置</div>
      <el-form-item label="今日打卡人数" prop="is_today_total">
        <el-radio-group v-model="form.is_today_total">
          <el-radio :label="1">显示</el-radio>
          <el-radio :label="0">隐藏</el-radio>
        </el-radio-group>
      </el-form-item>

      <div class="common-form">学习计划提醒</div>
      <el-form-item label="计划名称">
        <el-input v-model="form.plan_message_title" class="max-w460"></el-input>
      </el-form-item>
      <el-form-item label="学习时间">
        <el-time-select v-model="form.plan_message_time" :picker-options="{start: '07:00',step: '00:15',end: '23:00'}" placeholder="选择时间"></el-time-select>
        
        <div class="gray9">每天的XX点XX分出现消息提醒推送</div>
      </el-form-item>
      <el-form-item label="温馨提示">
        <el-input v-model="form.plan_message_remark" class="max-w460"></el-input>
      </el-form-item>

      <!-- <div class="common-form">自定义表单</div>
      <el-form-item label="表单标题">
        <el-input v-model="form.custom_form_title" class="max-w460"></el-input>
      </el-form-item>
      <el-form-item label="表单说明">
        <el-input type="textarea" v-model="form.custom_form_intro" :rows="5" class="max-w460"></el-input>
      </el-form-item> -->

      <div class="common-form">考研择校</div>
      <el-form-item label="搜索免费次数">
        <el-input v-model="form.school_free_count" class="max-w460" style="width:200px">
          <template slot="append">次</template>
        </el-input>
      </el-form-item>

      <div class="common-form">排行榜</div>
      <el-form-item label="坚持天数限制">
        <el-input v-model="form.ranking_restrict_daka_day" class="max-w460" style="width:200px">
          <template slot="append">天</template>
        </el-input>
        <p class="gray9">坚持天数，排行榜设置限制打卡至少N天才能进排行榜</p>
      </el-form-item>
      <el-form-item label="刷题正确率限制">
        <el-input v-model="form.ranking_restrict_count" class="max-w460" style="width:200px">
          <template slot="append">题</template>
        </el-input>
        <p class="gray9">刷题正确率，排行榜设置限制至少刷N题才能进排行榜</p>
      </el-form-item>
      <el-form-item label="显示人数">
        <el-input v-model="form.ranking_restrict_user_count" class="max-w460" style="width:200px">
          <template slot="append">人</template>
        </el-input>
        <p class="gray9">坚持天数和刷题正确率显示人数</p>
      </el-form-item>

      <div class="common-form">积分</div>
      <el-form-item label="">
        <el-button type="primary" icon="el-icon-plus" @click="addPoints">添加</el-button>
      </el-form-item>
      
      <el-form-item label="项目" prop="points">
        <el-table class="custom mt10" :data="form.points" border stripe>
          <el-table-column label="键值" width="100">
            <template slot-scope="scope"><el-input v-model="scope.row.key_name" ></el-input></template>
          </el-table-column>
          <el-table-column label="前N次" width="100">
            <template slot-scope="scope"><el-input type="number" v-model="scope.row.count" :disabled="scope.row.type!='day'"></el-input></template>
          </el-table-column>
          <el-table-column label="积分" width="100">
            <template slot-scope="scope"><el-input type="number" v-model="scope.row.point"></el-input></template>
          </el-table-column>
          <el-table-column label="类型" width="100">
            <template slot-scope="scope"><el-input v-model="scope.row.type" ></el-input></template>
          </el-table-column>
          <el-table-column label="类型名称" width="150">
            <template slot-scope="scope"><el-input v-model="scope.row.type_name"></el-input></template>
          </el-table-column>
          <el-table-column label="说明">
            <template slot-scope="scope"><el-input v-model="scope.row.describe"></el-input></template>
          </el-table-column>
        </el-table>
      </el-form-item>

      <el-form-item label="积分说明">
        <el-input v-model="form.score_intro" type="textarea" rows="10" class="max-w460"></el-input>
      </el-form-item>

      <div class="common-form">小程序审核版本设置（开发者）</div>
      <el-form-item label="线上版本">
        <el-input v-model="form.app_version" class="max-w460"></el-input>
      </el-form-item>

      <br>
      <br>
      <br>

      <!--提交-->
      <div class="common-button-wrapper">
        <el-button type="primary" @click="onSubmit" :loading="loading">保存</el-button>
      </div>
    </el-form>

  </div>
</template>
<script>
  import SettingApi from '@/api/study/setting.js';
  import {str2bool} from "@/utils/base.js";
  export default {
    data() {
      return {
        form: {
          is_open: false,
          is_form: 0,
          points: [],
          tags: [],
        },
        loading: false,
        tagVisible: false,
        tagValue: ''
      };
    },
    props:{
      settingData:Object,
      gradeList:Array
    },
    created() {
      this.form = this.settingData.data.basic.values;
      // this.form.is_open = JSON.parse(this.form.is_open);
      if (!this.form.tags){
        this.form.tags = [];
      }
      if (!this.form.points){
        this.form.points = [
          {key_name: '', point: '', describe: ''},
        ];
      }
      
    },
    methods: {
      /*标签*/
      tagClose(tag) {
        this.form.tags.splice(this.form.tags.indexOf(tag), 1);
      },

      tagInput() {
        this.tagVisible = true;
        this.$nextTick(_ => {
          this.$refs.tagInput.$refs.input.focus();
        });
      },

      tagInputConfirm() {
        let value = this.tagValue;
        if (value) {
          this.form.tags.push(value);
        }
        this.tagVisible = false;
        this.tagValue = '';
      },
      /*提交表单*/
      onSubmit() {
        let self = this;
        self.loading = true;
        let params = this.form;
        SettingApi.basic(params, true)
          .then(data => {
            self.loading = false;
            self.$message({
              message: '恭喜你，保存成功',
              type: 'success'
            });
          })
          .catch(error => {
            self.loading = false;
          });
      },
      // 添加
      addPoints(e){
        this.form.points.push({key_name: '', point: '', describe: '', type: 'day', type_name:'', count: 0});
      },
      // 删除
      delPoints(e){
        this.form.points.splice(e, 1);
        // this.form.points = this.initAnswer(this.form.points);
      },

    }
  };
</script>

<style>
.el-tag + .el-tag {
  margin-left: 10px;
}
.button-new-tag {
  margin-left: 10px;
  height: 32px;
  line-height: 30px;
  padding-top: 0;
  padding-bottom: 0;
}
.input-new-tag {
  width: 90px;
  margin-left: 10px;
  vertical-align: bottom;
}
</style>



// WEBPACK FOOTER //
// src/views/study/setting/part/Basic.vue